import { Link } from "react-router-dom";
import { Mail, Globe, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0A0D0F] overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-5">
          <Logo />
          <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
            Circular economy engineering for a Net Zero planet — from concept to creation,
            installation, commissioning and operation.
          </p>
          <div className="flex flex-col gap-2 text-sm">
            <a
              href="mailto:info@green-planet.tech"
              data-testid="footer-email-info"
              className="inline-flex items-center gap-2 text-gray-300 hover:text-lime transition-colors"
            >
              <Mail size={14} className="text-lime" /> info@green-planet.tech
            </a>
            <a
              href="mailto:sureshmir@green-planet.tech"
              data-testid="footer-email-suresh"
              className="inline-flex items-center gap-2 text-gray-300 hover:text-lime transition-colors"
            >
              <Mail size={14} className="text-lime" /> sureshmir@green-planet.tech
            </a>
            <p data-testid="footer-address" className="inline-flex items-center gap-2 text-gray-300">
              <MapPin size={14} className="text-lime" /> 38 Douglas Place, Bedfordview 2008, South Africa
            </p>
            <a
              href="https://www.green-planet.tech"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website-link"
              className="inline-flex items-center gap-2 text-gray-300 hover:text-lime transition-colors"
            >
              <Globe size={14} className="text-lime" /> www.green-planet.tech
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            {[
              ["About Us", "/about", "footer-link-about"],
              ["Founder", "/founder", "footer-link-founder"],
              ["Services & Tech", "/services", "footer-link-services"],
              ["Industries", "/industries", "footer-link-industries"],
              ["Contact", "/contact", "footer-link-contact"],
            ].map(([name, path, id]) => (
              <li key={path}>
                <Link
                  to={path}
                  data-testid={id}
                  className="text-gray-400 hover:text-white transition-colors inline-flex items-center gap-1 group"
                >
                  {name}
                  <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity text-lime" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime mb-5">Capabilities</p>
          <ul className="space-y-3 text-sm text-gray-400">
            <li>Steel & Metals Recycling Plants</li>
            <li>Renewable Generation & Storage</li>
            <li>Waste-to-Energy & Biofuels</li>
            <li>Air & Water Treatment</li>
            <li>Green Building Materials</li>
            <li>Mine Land Restoration</li>
          </ul>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="mt-16 font-display font-extrabold text-stroke whitespace-nowrap select-none text-[13vw] leading-none tracking-tight"
      >
        NET ZERO
      </div>

      <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-6 text-xs text-gray-500">
        <div>
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Green Planet Technologies Pty Ltd · Reg. No. K2025943399. All rights reserved.</p>
          <p className="mt-1 font-mono tracking-widest uppercase">Circular Economy · Net Zero · Planet Positive</p>
        </div>
        <div data-testid="footer-signatory" className="flex items-center gap-4">
          <img
            src="/assets/logo.jpeg"
            alt="Green Planet Technologies logo"
            className="logo-spin h-14 w-14 object-contain"
          />
          <div>
            <p className="text-sm font-semibold text-white">Suresh C. Mirchandani</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gray-500 mt-0.5">Promoter & Founder</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
